import React from 'react';
import PropTypes from 'prop-types';

class TimeElapsed extends React.Component {   

    constructor(props){
        super(props);
        this.start = this.start.bind(this);
        this.pause = this.pause.bind(this);
        this.reset = this.reset.bind(this);
        this.timer=null;
        this.state = {
            time : 0,
            play : false,
            completed : false,
            help : false,
            start : null
        }
    }
    componentWillMount(){ }
    
    componentDidMount(){ 


    }

 
    start(){
        if(this.timer) {window.clearInterval(this.timer)};
        this.setState({
            play : true,
            time : 0,
            completed : false,
            start : Date.now()
        })
        this.timer = window.setInterval(()=>{
            var delta = Date.now() - this.state.start; 
            this.setState({time :delta / 1000});
            
        }, 100);
    }
    pause(){
        if(this.timer) {window.clearInterval(this.timer)};
        this.props.onChange(this.state.time);
        this.setState({
            play : false
        })
    }
    reset(){
        if(this.timer) {window.clearInterval(this.timer)};
        this.setState({
            play : false,
            time : 0
        })
    }

    render(){
        const getMinutes = ()=>{
            let mins =  Math.floor(this.state.time/60);
            if(mins < 10) {
                return "0"+mins;
            }
            return mins;
        }

        const getSeconds = ()=>{
            if(this.state.time==0){
                return "00";
            }
            let seconds = Math.round(this.state.time % 60);
            
            if(seconds<10){
                return '0'+seconds;
            }
    
            return seconds;

            
        }

        if(this.state.time==0) return null;
    
        return (
            <div  className="TimeElapsed">
                <span>{getMinutes()}</span>:
                <span>{getSeconds()}</span>
                {/* <span>{this.state.time.toFixed(1)}</span> */}
                <style jsx>{`
                    
                    .TimeElapsed {
                        position: absolute;
                        bottom:10px;
                        right:10px;
                        background: #cbdfef;
                        padding:5px 15px !important;
                        font-size:32px!important;
                        color:#852c2e;
                        font-weight: bold!important;
                        text-align: center;
                        border:1px solid #504C4A!important;
                        letter-spacing: -0.1em;
                        font-family: 'Roboto Mono', monospace!important;
                    }    
                    @media all and (max-width:599px){
                        .TimeElapsed {
                        
                            font-size:28px!important;
 
                        }  

                     }

                    
                `}</style>
            </div>
        )
    }
}

TimeElapsed.propTypes = {
    
}

export default TimeElapsed;